import type { ModelOption, QuotaInfo } from '../services/api';

// The backend dates its quota in UTC, so the reset day must not shift with the user's timezone.
export const formatResetDate = (isoDate: string): string =>
  new Date(`${isoDate}T00:00:00Z`).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', timeZone: 'UTC' });

export const LOW_QUOTA_THRESHOLD = 10;

export const remainingAdvancedRequests = (quota: QuotaInfo | null): number | null => {
  if (!quota || quota.is_unlimited) return null;

  return Math.max(quota.limit - quota.used, 0);
};

export const findFallbackIndex = (modelOptions: ModelOption[], model?: ModelOption): number => {
  if (!model?.fallbackModel) return -1;

  return modelOptions.findIndex(o => o.model === model.fallbackModel && o.can_use !== false);
};
